import { useState, useRef, useEffect } from "react";

export default function SabiasQue({
	icono = "💬",
	texto = "Texto por defecto",
	position
}) {
	const [visible, setVisible] = useState(false);
	const [showAbove, setShowAbove] = useState( position === "above" ? true : false);
	const containerRef = useRef(null);

	const isSmallScreen = window.innerWidth <= 600;

	useEffect(() => {
		function handleClickOutside(event) {
			if (
				containerRef.current &&
				!containerRef.current.contains(event.target)
			) {
				setVisible(false);
			}
		}

		if (visible) {
			document.addEventListener("click", handleClickOutside);
		} else {
			document.removeEventListener("click", handleClickOutside);
		}

		return () => {
			document.removeEventListener("click", handleClickOutside);
		};
	}, [visible]);

	const handleToggleVisible = (e) => {
		e.stopPropagation();

		if (!visible && !position && containerRef.current) {
			const rect = containerRef.current.getBoundingClientRect();
			const estimatedTooltipHeight = 160;
			let spaceBelow = window.innerHeight - rect.bottom;
			let spaceAbove = rect.top;
			let node = containerRef.current.parentElement;

			while (node && node !== document.documentElement) {
				const style = window.getComputedStyle(node);
				const overflowY = style.overflowY || style.overflow;
				if (["hidden", "auto", "scroll", "clip"].includes(overflowY)) {
					const parentRect = node.getBoundingClientRect();
					spaceBelow = Math.min(spaceBelow, parentRect.bottom - rect.bottom);
					spaceAbove = Math.min(spaceAbove, rect.top - parentRect.top);
				}
				node = node.parentElement;
			}

			setShowAbove(
				spaceBelow < estimatedTooltipHeight && spaceAbove > spaceBelow,
			);
		}

		setVisible(!visible);
	};

	return (
		<div
			ref={containerRef}
			style={{
				position: "relative",
				display: "inline-block",
			}}
		>
			<div
				style={{
					width: 32,
					height: 32,
					borderRadius: "50%",
					backgroundColor: "#fff",
					border: "1px solid #ccc",
					boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					cursor: "pointer",
					fontSize: 16,
					position: "relative",
					zIndex: 9998,
				}}
				onClick={handleToggleVisible}
				onMouseEnter={(e) => {
					if (!isSmallScreen) handleToggleVisible(e);
				}}
				onMouseLeave={(e) => {
					if (!isSmallScreen) setVisible(false);
				}}
			>
				{icono}
			</div>

			{visible && (
				<div
					style={{
						position: "absolute",
						bottom: showAbove ? "120%" : "auto",
						top: showAbove ? "auto" : "120%",
						left: "50%",
						transform: "translateX(-50%)",
						backgroundColor: "#fffbe6",
						border: "2px solid #f5c400",
						borderRadius: 12,
						padding: "10px 14px",
						fontSize: 12,
						fontFamily: "'Poppins', sans-serif",
						color: "#444",
						width: 250,
						boxShadow: "2px 2px 6px rgba(0, 0, 0, 0.1)",
						zIndex: 10001,
						whiteSpace: "normal",
					}}
				>
					{texto}
				</div>
			)}
		</div>
	);
}
